/*@ngInject*/
const CheckboxFilterController = function ($scope, coreConstant, advancedFilterModel, localization) {

    this.$onInit = function () {

        this.tooltip = {
            delay: 750
        };

        localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then((translations) => {
            this.tooltip.message = translations.removeButtonTooltip;
        });

        this.isOpen = true;
    };

    this.handleChange = function () {
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
    };

    this.getComponentId = function (filterCriterionTemplate) {
        return this.advancedFilterType + 'AdvancedFilterType ' + filterCriterionTemplate.variableName;
    };

    this.handleRemove = function () {
        advancedFilterModel.unselectFilterCriterion(this.advancedFilterType, this.criterionTemplate.id);
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
    };

    $scope.$on(coreConstant.event.FILTER_CLEARED, function (event, criterionTemplateId) {
        if (criterionTemplateId === this.criterionTemplate.id) {
            this.criterionTemplate.value = '';
        }
    }.bind(this));
};

angular.module('umCore')
    .controller('checkboxFilterController', CheckboxFilterController);
